import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h24v24.615H0z" /><path d="M21.693 12.764L7.072 22.761a.675.675 0 01-.708.035.71.71 0 01-.364-.623V2.178c0-.26.14-.5.364-.623a.675.675 0 01.708.035l14.62 9.997a.712.712 0 01.308.588.712.712 0 01-.307.589z" fill="currentColor" fillRule="nonzero" /></g></svg>);